import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const labelFlyOutTermsFn = /* @__PURE__ */ createRecipe('labelFlyOutTerms', {}, [])

const labelFlyOutTermsVariantMap = {}

const labelFlyOutTermsVariantKeys = Object.keys(labelFlyOutTermsVariantMap)

export const labelFlyOutTerms = /* @__PURE__ */ Object.assign(memo(labelFlyOutTermsFn.recipeFn), {
  __recipe__: true,
  __name__: 'labelFlyOutTerms',
  __getCompoundVariantCss__: labelFlyOutTermsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: labelFlyOutTermsVariantKeys,
  variantMap: labelFlyOutTermsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, labelFlyOutTermsVariantKeys)
  },
  getVariantProps: labelFlyOutTermsFn.getVariantProps,
})